import { createFileRoute } from "@tanstack/react-router";

import EtimsVerifierPage from "@/features/dashboard/pages/etims-verifier";

export const Route = createFileRoute("/(app)/dashboard/invoice-intelligence")({
  component: () => <EtimsVerifierPage />,
});
